import { makeStyles } from "@material-ui/core/styles";
import { COLORS } from "../../../../styles/constants/colors";
import { FONTS } from "../../../../styles/constants/fonts";

export const useStyles = makeStyles({
  root: {
    color: COLORS.WHITE,
    background: `linear-gradient(116.22deg, ${COLORS.DARKCYAN} 16.5%, ${COLORS.PRIMARY} 55.76%, ${COLORS.CYAN_SECONDARY} 83.5%) right center / 200%`,
    border: 0,
    margin: "0px",
    fontSize: "18px",
    lineHeight: "20px",
    fontFamily: FONTS.PRIMARY,
    padding: "14px 16px",
    borderRadius: "2px",
    transitionDelay: "0s",
    transitionDuration: "350ms",
    transitionProperty: "all",
    transitionTimingFunction: "ease",
    textTransform: "none",
    boxShadow: "0px 8px 12px rgba(95, 107, 122, 0.25)",
    "&:hover": {
      boxShadow: "0 8px 12px rgba(33, 41, 52, 0.25)",
      backgroundPosition: "left center",
    },
    "&:disabled": {
      background: COLORS.BLUE,
      color: COLORS.WHITE,
    },
  },
});
